import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const devToolsLocalStorageKey = "jm-dev-tools";

const devToolsConfigAtom = atomWithStorage(
  devToolsLocalStorageKey,
  {
    reactQueryDevTools: {
      enabled: false,
    },
    scratchPad: {
      enabled: false,
    },
    sentryLogging: {
      enabled: false,
    },
    requestInstrumentation: {
      enabled: false,
    },
  },
  undefined,
  {
    getOnInit: true,
  },
);

export const sentryLoggingEnabledAtom = atom(
  (get) => get(devToolsConfigAtom).sentryLogging?.enabled ?? true,
);

export default devToolsConfigAtom;
